module.exports = __webpack_public_path__ + "img/pic_tic@3x.f1719f32.png";